module.exports = __webpack_public_path__ + "static/media/app-config.edf28b4d.png";